import $ from 'jquery';

function paintFeedInstagram (response) {
    let instafeed = '';
  
    for (let i = 0;
      (i < response.data.length); i++) {
      instafeed += `<li class="cell instafeed-list__item"> 
                      <a class="item-instafeed__link" href="${response.data[i].link}" target="_blank" rel="noopener">
                       <img class="item-instafeed__img" src="${response.data[i].images.standard_resolution.url}" 0 />
                      </a> 
                    </li>`;
    }
    $('#instafeed-list').append(instafeed);
}

function apiInstagram (url, callback) {
  $.ajax({
    url: url,
    success: callback
  });
}

$(document).ready(function(){
  const access_token = '';
  apiInstagram(`https://api.instagram.com/v1/users/self/media/recent/?access_token=${access_token}`, paintFeedInstagram);
});
